import { ApiResponse, TokenData,  SatisfactionLevel } from '../models';
import * as http from './http';
import ApiService from './service';

export class SatisfactionLevelService extends ApiService {
  public async loadAllSatisfactionLevel() {
    const url = `${this.apiDomain}/api/settings/customer-satisfaction-levels`;

    const resposne = await http.get<ApiResponse<SatisfactionLevel[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async createSatisfactionLevel(data: SatisfactionLevel, id?: string) {
    const url = `${this.apiDomain}/api/settings/customer-satisfaction-levels`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async updateSatisfactionLevel(data: SatisfactionLevel, id?: string) {
    const url = `${this.apiDomain}/api/settings/customer-satisfaction-levels/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async deleteSatisfactionLevel(id?: string) {
    const url = `${this.apiDomain}/api/settings/customer-satisfaction-levels/${id}`;

    const response = await http.remove<ApiResponse<SatisfactionLevel>>(
      url,
      this.store
    );
    return response.data;
  }
}
